import React from 'react';
import { IconButton } from '@material-ui/core';
import { AddCircleOutlineOutlined } from '@material-ui/icons';
import { useFormContext } from '../FormContext';
import ConfigHeader from './components/ConfigHeader';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import FormConfigEventTransition from './FormConfigEventTransition';
import { ConfigList } from './components/ConfigList';
export const FormConfigEventTransitionList = ({ event }) => {
    const { addTransition, updateTransition, moveTransition, deleteTransition } = useFormContext();
    const { transitions = [] } = event;
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigHeader, { end: React.createElement(IconButton, { size: 'small', onClick: () => addTransition(event) },
                React.createElement(AddCircleOutlineOutlined, null)) }, "Transition"),
        React.createElement(DragDropContext, { onDragEnd: result => {
                const { source, destination } = result;
                // dropped outside the list
                if (!destination) {
                    return;
                }
                moveTransition(event, source.index, destination.index);
            } },
            React.createElement(Droppable, { droppableId: 'transitions' }, provided => (React.createElement(ConfigList, { className: 'transition-list', ref: provided.innerRef },
                transitions.map((transition, index) => (React.createElement(Draggable, { key: index, index: index, draggableId: `draggable-${index}` }, (provided, snapshot) => (React.createElement(FormConfigEventTransition, Object.assign({ className: snapshot.isDragging ? 'dragging' : '', ref: provided.innerRef, event: event, transition: transition }, provided.draggableProps, { dragHandleProps: provided.dragHandleProps, onDelete: () => deleteTransition(event, index), onChangeTarget: target => updateTransition(event, index, { target }) })))))),
                provided.placeholder))))));
};
export default FormConfigEventTransitionList;
//# sourceMappingURL=FormConfigEventTransitionList.js.map